import { Box, Modal, Typography, Button } from "@mui/material";
import React from "react";
import { styles } from "./Styles";
import { Constants } from "../../utils/constants/Constants";

const CustomPopup = ({
  open,
  handleClose,
  handleConfirm,
  warning,
  title,
  popupFor,
  cancel = true,
}) => {
  const classes = styles;

  return (
    <Modal
      open={open}
      style={{ overflowX: "visible" }}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={classes.modal}>
        <Typography sx={classes.action} gutterBottom>
          {title}
        </Typography>
        <Typography sx={classes.msg} gutterBottom>
          {warning}
        </Typography>

        <Box
          display={"flex"}
          alignItems={"center"}
          gap="10px"
          justifyContent={"center"}
          mt={2}
        >
          <Button
            variant="contained"
            disableElevation
            sx={classes.btn}
            onClick={handleConfirm}
          >
            {Constants.BUTTON_TEXT_YES}
          </Button>
          <Button
            variant="outlined"
            disableElevation
            sx={classes.btn}
            onClick={handleClose}
          >
            {Constants.BUTTON_TEXT_NO}
          </Button>
          {cancel && (
            <Button
              variant="outlined"
              disableElevation
              sx={classes.btn}
              onClick={handleClose}
            >
              {Constants.BUTTON_TEXT_CANCEL}
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default CustomPopup;
